<div class="organization-switcher-wrapper d-flex justify-content-center mx-auto p-2 mt-3">
    @if (isLoading()) {
        <div class="d-flex justify-content-center align-items-center">
            <div class="spinner-border text-light" role="status" aria-label="Loading organizations">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    } @else {
        @if (isEditing() && hasMultipleOrgs()) {
            <div class="organization-switcher w-90">
                <ms-typeahead
                    [items]="organizationsTypeaheadList"
                    [selectedItem]="selectedOrganization()"
                    [serverSideSearch]="isStaff()"
                    [isSearching]="isSearching()"
                    [hasMore]="hasMore()"
                    [isLoadingMore]="isLoadingMore()"
                    (selectedItemChange)="onOrganizationSelected($event)"
                    (searchChanged)="onSearchChanged($event)"
                    (loadMore)="onLoadMore()"
                    (blurred)="onTypeaheadBlurred()"
                    [placeholder]="'Select Organization'"
                ></ms-typeahead>
            </div>
        } @else {
            @if (hasMultipleOrgs()) {
                <div class="organization-display cursor-pointer py-2 text-light d-flex align-items-center gap-2" (click)="enterEditMode()">
                    <span class="organization-name text-truncate flex-grow-1" [title]="selectedOrganization()?.label">
                        {{ selectedOrganization()?.label }}
                    </span>
                    <fa-duotone-icon icon="chevron-down" class="chevron-icon fs-6 flex-shrink-0" secondaryOpacity="0.9" size="lg" title="Select another Organization to view and edit."/>
                </div>
            }
            @else {
                <div class="overflow-hidden py-2 text-light d-flex align-items-center gap-2" (click)="enterEditMode()">
                    <span class="organization-name text-truncate flex-grow-1" [title]="selectedOrganization()?.label">
                        {{ organizationsList.length === 1 || selectedOrganization() ? selectedOrganization()?.label : 'No Organization Memberships' }}
                    </span>
                </div>
            }
        }
    }
</div>
